import { COLOR_PALETTE } from 'constants/ui';
import { getPersonFullName } from 'utils/loanApplication';

// Avatar palette for CRM contact indicators. A contact is always mapped to the
// same color so the indicator is stable across renders and screens.
const AVATAR_COLORS = [
  COLOR_PALETTE.BLUE[8],
  COLOR_PALETTE.CYAN[8],
  COLOR_PALETTE.ORANGE[8],
  COLOR_PALETTE.PURPLE[8],
  COLOR_PALETTE.BLUE_GRAY[7],
];

export const getContactDisplayName = contact =>
  getPersonFullName(contact || undefined) || 'View contact';

export const getContactAvatarColor = contact => {
  const key = contact?.contactId || getContactDisplayName(contact);
  const hash = [...String(key)].reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};
